// Per-course copy, keyed by the slugs in app/data/courses.ts.
const ar = {
  badgeNew: "جديد",

  ai: {
    title: "الذكاء الاصطناعي وتعلّم الآلة",
    short:
      "ابنِ تطبيقات ذكية، من أسس تعلّم الآلة إلى النماذج اللغوية الكبيرة ووكلاء الذكاء الاصطناعي.",
    long: "ابدؤوا بلغة Python ومعالجة البيانات اللتين يقوم عليهما هذا المجال، ثم اعملوا على أسس تعلّم الآلة: كيف يتعلّم النموذج من البيانات، ولماذا يقع في فرط التخصيص، وكيف تميّزون النتيجة الجيدة من نتيجة الحظ. ومن هناك تنتقلون إلى الشبكات العصبية والتعلّم العميق، ثم إلى الأدوات التي تعيد تشكيل هذه الصناعة الآن، بما في ذلك النماذج اللغوية الكبيرة (LLMs)، وهندسة الأوامر، والاسترجاع، ووكلاء الذكاء الاصطناعي (AI agents) الذين يستدعون أدوات حقيقية. وتختمون ببناء تطبيق خاص بكم ونشره. لا تُفترض أي معرفة رياضية تتجاوز المرحلة الثانوية، وكل جلسة تطبيقية بوجود مدرّب إلى جانبكم.",
    level: "من المبتدئ إلى المتقدّم",
    duration: "10-14 أسبوعًا",
    topics: [
      "Python للذكاء الاصطناعي والبيانات",
      "أسس تعلّم الآلة",
      "الشبكات العصبية والتعلّم العميق",
      "النماذج اللغوية الكبيرة (LLMs)",
      "هندسة الأوامر",
      "بناء وكلاء الذكاء الاصطناعي وتطبيقاته",
    ],
  },

  algorithms: {
    title: "الخوارزميات",
    short: "صمّم الخوارزميات ونفّذها لحلّ المشكلات المعقّدة بكفاءة.",
    long: "تعلّموا أن تقدّروا كلفة البرنامج قبل تشغيله. يبدأ المساق بالترتيب والبحث وتدوين Big-O، ثم يتدرّج عبر العودية والتراجع والبرمجة الديناميكية والطرق الجشعة ونظرية الرسوم البيانية. يُدرَّس كل موضوع بأن تكتبوا الخوارزمية بأنفسكم ثم تكسروها، لتفهموا أين تفشل ولماذا جاء تطبيق المكتبة القياسية على النحو الذي هو عليه. هذا هو المساق الذي يجعل المقابلات التقنية في المتناول، والذي يفصل بين من يستطيع كتابة الشيفرة ومن يستطيع الحكم على صمودها تحت الضغط.",
    level: "من المبتدئ إلى المتقدّم",
    duration: "8-12 أسبوعًا",
    topics: [
      "الترتيب والبحث",
      "التعقيد وتدوين Big-O",
      "العودية والتراجع",
      "البرمجة الديناميكية",
      "نظرية الرسوم البيانية",
      "الخوارزميات الجشعة",
    ],
  },

  programming: {
    title: "أساسيات البرمجة",
    short:
      "ابنِ أساسًا متينًا في الترميز وحلّ المشكلات وكتابة الشيفرة النظيفة.",
    long: "نقطة الانطلاق إن لم تكتبوا سطر شيفرة واحدًا من قبل. تبدؤون بالمتغيّرات والأنواع والتحكّم في التدفّق والحلقات، ثم تنتقلون إلى الدوال والنطاق وبناء البرنامج بحيث يبقى مقروءًا كلما كبر. وفي الطريق تصادفون البرمجة الكائنية التوجّه ومعالجة الأخطاء والعادات التي تفصل الشيفرة التي تعمل فحسب عن شيفرة يستطيع سواكم صيانتها. ينصبّ التركيز طوال المساق على حلّ المشكلات لا على حفظ الصياغة: في النهاية تصبحون قادرين على أخذ مشكلة مصوغة بلغة عادية وتحويلها بأنفسكم إلى برنامج يعمل.",
    level: "مبتدئ",
    duration: "6-10 أسابيع",
    topics: [
      "المتغيّرات وأنواع البيانات",
      "التحكّم في التدفّق والحلقات",
      "الدوال والنطاق",
      "البرمجة الكائنية التوجّه",
      "معالجة الأخطاء",
      "أساسيات الشيفرة النظيفة",
    ],
  },

  architecture: {
    title: "تصميم البرمجيات وبنيتها",
    short: "مبادئ لأنظمة برمجية قابلة للتوسّع والصيانة.",
    long: "لمن يستطيعون فعلًا بناء الميزات ويريدون الآن تصميم الأنظمة. يغطّي المساق مبادئ SOLID وأنماط التصميم الجديرة بالمعرفة، ثم ينتقل إلى تصميم الأنظمة بمعناه الدقيق: كيف تفكّكون مجالًا، وأين ترسمون حدود الخدمات، ومتى تنفع الخدمات المصغّرة ومتى تكون خطأً باهظ الثمن. تعالجون قابلية التوسّع والتخزين المؤقت والأداء وأنماط الإخفاق على بنى حقيقية، وتتمرّنون على كتابة الوثائق التقنية التي تحظى بموافقة على التصميم. توقّعوا أن تقضوا في الدفاع عن قراراتكم وقتًا يوازي ما تقضونه في اتخاذها.",
    level: "من المتوسّط إلى المتقدّم",
    duration: "8-12 أسبوعًا",
    topics: [
      "مبادئ SOLID",
      "أنماط التصميم",
      "تصميم الأنظمة",
      "قابلية التوسّع والأداء",
      "الخدمات المصغّرة",
      "التوثيق التقني",
    ],
  },

  web: {
    title: "تطوير الويب",
    short: "ابنِ تطبيقات ويب حديثة، من الواجهة الأمامية إلى الخلفية.",
    long: "ابنوا تطبيقات الويب من المتصفّح وصولًا إلى قاعدة البيانات. تبدؤون بلغة HTML الدلالية وتخطيط الصفحات الحديث بلغة CSS، ثم JavaScript على نحوٍ سليم لا كمجموعة قصاصات، ثم React وكيف تُعرض شجرة المكوّنات فعلًا. ويغطّي النصف الثاني Node.js وتصميم واجهة برمجة، والتخاطب مع قاعدة بيانات، والمصادقة، ونشر النتيجة كي يستطيع الآخرون استخدامها. تخرجون بتطبيق متكامل بنيتموه بأنفسكم، وبفهمٍ لما يحدث بين كتابة عنوان URL وظهور الصفحة.",
    level: "من المبتدئ إلى المتقدّم",
    duration: "10-14 أسبوعًا",
    topics: [
      "HTML وCSS",
      "JavaScript",
      "React",
      "Node.js وواجهات البرمجة",
      "قواعد البيانات",
      "النشر",
    ],
  },

  mobile: {
    title: "تطوير تطبيقات الجوّال",
    short: "أطلق تطبيقات لنظامي iOS وAndroid، أصلية ومتعددة المنصّات.",
    long: "أطلقوا التطبيقات على منصّتي الجوّال الكبريين معًا. تعملون أولًا بالتطوير الأصلي، بلغة Swift على iOS ولغة Kotlin على Android، كي تفهموا أعراف كل منصّة بدل مصارعتها عبر طبقة تجريد. ثم تبنون التطبيق نفسه متعدد المنصّات بلغتي Flutter وReact Native، وترون بدقّة ما يكلّفكم كل نهج. يغطّي المساق إدارة الحالة والتخزين المحلي والتعامل مع واجهات برمجة الجهاز، والأجزاء التي لا يعلّمها أحد: مراجعة متجر التطبيقات، وإدارة الإصدارات، وطرح تحديث دون أن تعطبوا تجربة من يستخدمون التطبيق أصلًا.",
    level: "متوسّط",
    duration: "10-14 أسبوعًا",
    topics: [
      "Swift (iOS)",
      "Kotlin (Android)",
      "Flutter",
      "React Native",
      "الحالة والتخزين",
      "النشر على المتاجر",
    ],
  },

  server: {
    title: "تطوير قواعد البيانات والخوادم",
    short: "صمّم وشغّل قواعد البيانات وواجهات البرمجة وعمليات النشر.",
    long: "كل ما يجري بعد أن تغادر الطلبية المتصفّح. تتعلّمون نمذجة البيانات على نحوٍ سليم بلغة SQL، ومتى يكون مخزن المستندات أو مخزن المفتاح-القيمة هو الجواب الأفضل، وكيف تقرؤون خطة الاستعلام حين يبطؤ شيء ما. ومن هناك يتناول المساق البرمجة على جانب الخادم، وتصميم واجهات REST وGraphQL، والمصادقة وأخطاء الأمان التي تتصدّر العناوين، ثم التخزين المؤقت وطوابير الخلفية حين تقوم طلبية واحدة بأكثر مما ينبغي. ويُختتم بالنشر والمراقبة والجانب التشغيلي المتمثّل في إبقاء الخدمة عاملة بعد أن يعتمد عليها مستخدمون حقيقيون.",
    level: "متوسّط",
    duration: "8-12 أسبوعًا",
    topics: [
      "SQL وNoSQL",
      "البرمجة على جانب الخادم",
      "واجهات REST وGraphQL",
      "المصادقة والأمان",
      "التخزين المؤقت والطوابير",
      "النشر وDevOps",
    ],
  },

  career: {
    title: "السيرة الذاتية والبحث عن عمل",
    short:
      "اكتب سيرة ذاتية تفتح لك أبواب المقابلات، وأدر بحثًا عن عمل ينتهي بعرض.",
    long: "الحصول على وظيفة مهارة قائمة بذاتها، منفصلة عن القدرة على أداء العمل نفسه. تبدأ الدورة بكيفية سير التوظيف فعليًا: من يقرأ سيرتك الذاتية، وكم يستغرق ذلك، وما الذي تستبعده برامج الفرز قبل أن يراه أي إنسان. تعيد كتابة سيرتك وملفيك على LinkedIn وGitHub وفق هذا الواقع، وتبني معرض أعمال يثبت ما تقوله، وتتعلم إيجاد فرص خارج مواقع التوظيف التي يحدّثها الجميع باستمرار. ثم تتدرب على بقية المسار: التقديم، والمقابلات عبر جلسات محاكاة وملاحظات صريحة، والتفاوض على العرض دون التقليل من قيمتك. تغطي المواد سوق العمل الألماني والأوروبي إضافة إلى التقديم الدولي.",
    level: "جميع المستويات",
    duration: "4-6 أسابيع",
    topics: [
      "كتابة السيرة الذاتية وبنيتها",
      "ملفات LinkedIn وGitHub",
      "بناء معرض أعمال",
      "إيجاد الفرص والتقديم",
      "التدرب على المقابلات",
      "التفاوض على الراتب",
    ],
  },
};

export default ar;
